function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="15" height="16" viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.438 1.375h-2.376V.187H9.876v1.188h-4.75V.187H3.937v1.188H1.563c-.656 0-1.188.532-1.188 1.188v11.874c0 .656.532 1.188 1.188 1.188h11.874c.656 0 1.188-.532 1.188-1.188V2.563c0-.656-.532-1.188-1.188-1.188zm0 13.063H1.562V6.124h11.876v8.313zm0-9.5H1.562V2.563h2.375V3.75h1.188V2.562h4.75V3.75h1.188V2.562h2.374v2.376z" fill="#000" fillRule="nonzero" /></svg>;
});


// WEBPACK FOOTER //
// ./src/images/calendar.svg